export default __webpack_public_path__ + "static/210526_妲絲刷關活動熱更完成_en-b07d02d12b8989753be20040f3e9477e.webp";